<template>
  <div class="zoey">
    <CommonHeader ></CommonHeader>
    <slot />
  </div>
  
</template>
<script setup>
</script>
<style lang="scss" scoped>
.zoey{
  background: $primary-color;
  border-radius: 5px;
  color: $zoey-black;
}

</style>
